import { MedicalRecordFileStorageService } from '../services/MedicalRecordFileStorageService';
import { supabase } from '../config/supabase';

const MEDICAL_RECORDS_BUCKET = 'medical-records';

const pickAttachmentValue = (attachment: unknown, keys: string[]): string => {
  if (!attachment || typeof attachment !== 'object') {
    return '';
  }

  const candidate = attachment as Record<string, unknown>;

  for (const key of keys) {
    const value = candidate[key];
    if (typeof value === 'string' && value.trim().length > 0) {
      return value;
    }
  }

  return '';
};

const getPrimaryAttachment = (recordAttachments: unknown): unknown => {
  if (Array.isArray(recordAttachments) && recordAttachments.length > 0) {
    return recordAttachments[0];
  }

  if (recordAttachments && typeof recordAttachments === 'object') {
    return recordAttachments;
  }

  return null;
};

export const getMedicalRecordAttachmentPath = (recordAttachments: unknown): string => {
  const attachment = getPrimaryAttachment(recordAttachments);
  return pickAttachmentValue(attachment, ['path']);
};

export const getMedicalRecordAttachmentUrl = (recordAttachments: unknown): string => {
  const attachment = getPrimaryAttachment(recordAttachments);
  return pickAttachmentValue(attachment, ['url', 'fileUrl', 'downloadUrl', 'signedUrl']);
};

export const getMedicalRecordDownloadUrl = async (recordAttachments: unknown): Promise<string> => {
  const path = getMedicalRecordAttachmentPath(recordAttachments);
  const directUrl = getMedicalRecordAttachmentUrl(recordAttachments);

  if (path && path.startsWith('tenants/')) {
    return MedicalRecordFileStorageService.getDownloadUrl(path);
  }

  if (path) {
    const { data, error } = await supabase.storage
      .from(MEDICAL_RECORDS_BUCKET)
      .createSignedUrl(path, 300);

    if (error) {
      throw error;
    }

    if (data?.signedUrl) {
      return data.signedUrl;
    }
  }

  if (directUrl) {
    return directUrl;
  }

  throw new Error('Documento sem arquivo associado.');
};
